module.exports = __webpack_public_path__ + "static/media/ElementApp.fe7bc8d6.png";